import { useEffect, useRef, useState } from 'react'

/** The mobile navigation drawer: whether it is open, and where focus goes. */
export function useMobileNav() {
  const [open, setOpen] = useState(false)

  // The drawer takes focus when it opens and gives it back to the toggle when
  // it closes, so a keyboard user is never left behind it.
  const toggleRef = useRef<HTMLButtonElement>(null)
  const wasOpen = useRef(false)
  useEffect(() => {
    if (open) {
      document.querySelector<HTMLElement>('#navigation .nav-item')?.focus()
    } else if (wasOpen.current) {
      toggleRef.current?.focus()
    }
    wasOpen.current = open
  }, [open])

  // Escape closes the drawer, wherever focus is.
  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') setOpen(false)
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [])

  return {
    open,
    toggle: () => setOpen((was) => !was),
    close: () => setOpen(false),
    toggleRef,
  }
}
